export default __webpack_public_path__ + "static/media/script_text.d5d04c98.txt";